import * as $ from 'jquery';
import 'bootstrap';

/**
 * @module c050 siteSearch
 * search form logic for help page search bar
 *
 * @author Maneesh Pokhriyal <maneesh.pokhriyal@mirumagency.com>
 */
export class siteSearch {

	private $form = $('#searchpagebar-form');
	private searchBar = $('#search-searchbar');

	formAction = this.$form.attr('action');
	lang = this.$form.attr('lang');

	/**
	 * @function initSearchForm
	 */
	initSearchForm(): void {
		let _self = this;
		let searchButton = _self.searchBar.find('#search-button');

		if (localStorage['mas-search'] != null) {

			var data = JSON.parse(localStorage['mas-search']);
			data.reverse();
			var limit = 3;
			if(data != null){
			   $.each(data, function(i:number, item:any) {
				   if(i > limit){
					  return false;
				   }
				   var item = JSON.parse(data[i]) ;
				   var url = _self.formAction + encodeURI(item.text) +"?" + "language=" + _self.lang ;
				   $('#search-history ul').append(
					   $('<li>').addClass("history__item")
						   .append(
							   $('<a>')
								   .attr('href',url)
								   .attr("target","_blank")
								   .attr('aria-label', item.text)
						   .append(item.text)
					));
			   });
			 }
		}
	}

	/**
	 * @function submitForm
	 * form submission logic
	 * parse values as form action and submit to trigger redirect
	 * which brings user to mab help portal
	 */
	submitForm(): void {
		let _self = this;
		let $searchInput = $("#search-input");

		_self.$form.submit(function () {

			var text = $searchInput.val() ;
			var data = localStorage['mas-search'];
			var obj = {};

			if (text != '') {

				 obj = { text };
				 var parsed  = JSON.stringify(obj) ;
				var arr:Array<any> = [];

				 if (data == null) {
					arr[0] = parsed ;
					localStorage.setItem("mas-search", JSON.stringify(arr));

				 }else {
					 var dataList = JSON.parse(localStorage['mas-search']);
					 $.each(dataList, function(i:number, item:any) {
						  arr[i] = dataList[i] ;
					 });
					 arr[arr.length] = parsed ;
					 localStorage['mas-search'] = JSON.stringify(arr);
				 }
			 }
			 // search text

			 var encodedText = encodeURI(text);

			 var url = _self.formAction + encodedText + "?" + "language=" + _self.lang;
			  _self.$form.attr('action', url);
			  _self.$form.attr('target', '_blank');
		 });
	}

	/**
	 * @function ctaButton
	 * trigger form submit when clicking on search button
	 */
	ctaButton(): void {
		let _self = this;
		let $searchBtn = $('#search-button');

		$searchBtn.click(function () {
			_self.$form.submit();
		});
	}
}

let scope:Element = document.querySelector('#search-searchbar');
if (scope){
	try {
		let sitesearch = new siteSearch();
		sitesearch.initSearchForm();
		sitesearch.submitForm();
		sitesearch.ctaButton();
	} catch(e) {console.error(e);}
}
